import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Link } from 'components/core/Link';

export default function Crumb({
	children,
	label,
	href,
	isLast,
	to,
	tertiary,
	className,
}) {
	return React.createElement(
		!isLast ? Link : Text,
		{
			to,
			href,
			secondary: !tertiary,
			tertiary: !isLast && tertiary,
			color: isLast && tertiary && 'white',
			className,
		},
		children || label,
	);
}

Crumb.propTypes = {
	children: PropTypes.node,
	label: PropTypes.string.isRequired,
	href: PropTypes.string,
	isLast: PropTypes.bool,
	to: PropTypes.string,
	tertiary: PropTypes.bool,
	className: PropTypes.string,
};
